
import React, { useState, useContext } from 'react'
import { Detail as DetailComponent, Confirm, useDrawer, SplitButton, useRelationshipInjector, useFormatter } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from "src/mtska-frontend-data-provider/hooks/useLoadOne.hooks"
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'

const dataProviderName = 'cashflows/cashflowrecord';
const drawerRouteBase = 'cashflowrecords';

const Detail = (params) => {
    const { t } = useTranslation();
    const { activate, close: closeDrawer } = useDrawer()
    const { userCapabilities, existingModules } = useContext(AppContext);
    const { injectToDetail } = useRelationshipInjector();
    const { formatCurrency } = useFormatter();

    // DATA PROVIDER
    const { doAction, item, save, loadOne, destroy, errorMessage, errors, saving, reloadCounter } = useDataProvider(dataProviderName, params.multipart)

    const { modelName, detailConfig } = existingModules[dataProviderName]

    useLoadOne({ loadOne, params, reloadCounter })

    const [editing, setEditing] = useState(false)

    const handleSave = (data) => {
        save({ ...data, filters: params.filters }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'))
    }

    const [confirmDelete, setConfirmDelete] = useState();
    const handleDelete = (id) => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={() => {
                    destroy && destroy(id);
                    closeDrawer();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Item elimination")}>
                {t("Are you sure to remove this element?")}
            </Confirm>
        );
    }

    const [open, setOpen] = useState(false)

    const handleClose = (_, reason) => {
        if (reason === 'clickaway') return
        setOpen(false)
    }

    injectToDetail(item?.data, 'car', params.filters);
    injectToDetail(item?.data, 'legalEntity', params.filters?.legalEntity);

    const { data } = item || {}

    const { amount_numeric = 0, _id } = data || {}

    const label = amount_numeric >= 0 ? t('Voce di ricavo') : t('Voce di costo')

    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
            >
                <Alert onClose={handleClose} severity='success' sx={{ width: '100%' }} variant="filled">
                    {label} creata correttamente
                </Alert>
            </Snackbar>
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{ ...item?.data }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                title={(item?.data?.description) ? item?.data?.description : t("New")}
                subtitle={formatCurrency(item?.data?.amount)}
                rightButtons={[
                    <SplitButton
                        actions={[
                            {
                                //disabled: userCapabilities && !userCapabilities[dataProviderName+'.split'],
                                disabled: false,
                                icon: "faSplit",
                                label: t('Split Record'),
                                onClick: () => { activate(drawerRouteBase + '/splitRecord', { detailStack: params.detailStack ?? {} }); }
                            },
                            {
                                //disabled: userCapabilities && !userCapabilities[dataProviderName+'.delete'],
                                disabled: false,
                                icon: "faPlus",
                                label,
                                onClick: () => {
                                    const action = 'createContoEconomico'
                                    const data = { _id }
                                    doAction({ action, data, model: dataProviderName }).then((data) => {
                                        const { item } = data || {}
                                        //console.log('item', item)
                                        item && setOpen(true)
                                    })
                                }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.delete'],
                                icon: "faTrash",
                                label: t('Delete'),
                                onClick: () => { handleDelete(item.data?.id); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.log'],
                                icon: "faClipboardList",
                                label: t('Log'),
                                onClick: () => {
                                    activate('wizards/log', {
                                        model: dataProviderName,
                                        entityId: item.data.id,
                                        detailStack: params.detailStack ?? {},
                                        title: t("Item elimination")
                                    });
                                }
                            },

                        ]}
                    />
                ]}
                {...params}
            />
            {confirmDelete}
        </>
    )
}

export default Detail;


